var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFaq3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60.97 60.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".k{fill:url(#i);}.l{fill:url(#h);}.m{fill:url(#j);}.n{mask:url(#d);}.o{mask:url(#f);}.p{fill:none;}.q,.r{fill:#fff;}.s{fill:#cacbcd;}.t{fill:#24126a;}.u,.v{fill:#463c9c;}.w{fill:#afb1b4;mix-blend-mode:multiply;opacity:.53;}.x{clip-path:url(#c);}.y{clip-path:url(#b);}.a`{clip-path:url(#e);}.aa{clip-path:url(#g);}.ab{isolation:isolate;}.v{opacity:.8;}.r{opacity:.96;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 60.97,
    height: 60.97
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 60.97,
    height: 60.97
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    x: -10.16,
    y: -7.9,
    width: 81.3,
    height: 70.01,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M30.49,60.97c16.84,0,30.49-13.65,30.49-30.49S47.33,0,30.49,0,0,13.65,0,30.49s13.65,30.49,30.49,30.49"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    x: -10.16,
    y: -7.9,
    width: 81.3,
    height: 70.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    x: -10.16,
    y: -7.9,
    width: 81.3,
    height: 71.54
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    x: -10.16,
    y: -7.9,
    width: 81.3,
    height: 71.54,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "aa"
  }, /*#__PURE__*/React.createElement("image", {
    transform: "translate(-10.16 -7.9) scale(.54)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 9.71,
    y1: 30.49,
    x2: 51.26,
    y2: 30.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ffee95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ffef99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -397.28,
    y1: 1011.36,
    x2: -391.46,
    y2: 1000.87,
    gradientTransform: "translate(-1044.06 202.66) rotate(-120.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5b7b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#c9cacb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#e6e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1e2e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -392.31,
    y1: 1007.04,
    x2: -393.35,
    y2: 1005.14,
    gradientTransform: "translate(-1044.06 202.66) rotate(-120.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbdcdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eeeeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ab"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "y"
  }, /*#__PURE__*/React.createElement("g", {
    className: "x"
  }, /*#__PURE__*/React.createElement("g", {
    className: "n"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a`"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M30.49,60.97c16.84,0,30.49-13.65,30.49-30.49S47.33,0,30.49,0,0,13.65,0,30.49s13.65,30.49,30.49,30.49"
  }), /*#__PURE__*/React.createElement("g", {
    className: "o"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "w",
    x: -10.16,
    y: -7.9,
    width: 81.3,
    height: 71.54
  })))))), /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 30.49,
    cy: 30.49,
    r: 20.78
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M16.52,34.67v1.01h0s0,.03,.02,.04l11.02,6.32s.1,.02,.14,0l1.8-1.04s.03-.03,.03-.04h0v-1.03l-.88,.5-10.17-5.84s-.1-.02-.14,0l-.62,.36-1.22-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M18.49,33.57l11.02,6.32s.03,.06,0,.08l-1.8,1.04s-.1,.03-.14,0l-11.02-6.32s-.03-.06,0-.08l1.8-1.04s.1-.03,.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M18.11,34.15l10.39,5.96s.02,.04,0,.06l-.45,.26s-.07,.02-.1,0l-10.39-5.96s-.02-.04,0-.06l.45-.26s.07-.02,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M17.56,34.47l.21,.12,.24-.14s.07-.02,.1,0l10.18,5.84,.21-.12s.03-.04,0-.06l-10.39-5.96s-.07-.01-.1,0l-.45,.26s-.03,.04,0,.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M44.31,23.88l-8.65-4.96h0c0,1.55-1.08,3.44-2.42,4.21l-11.92,6.92c-1.57,.91-2.85,3.13-2.84,4.95h0l8.65,4.96h0c0-1.82,1.27-4.04,2.84-4.95l11.92-6.92c1.34-.78,2.42-2.66,2.42-4.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.49,35.01l8.65,4.96c0-.08,0-.16,0-.24h0l-8.65-4.96c0,.08,0,.16,0,.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "31.01 31.29 32.97 32.41 32.78 32.52 30.82 31.4 31.01 31.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "30.01 30.71 30.71 31.12 30.52 31.23 29.82 30.82 30.01 30.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "29.23 30.27 29.71 30.54 29.52 30.65 29.04 30.37 29.23 30.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "32.33 31.55 33.4 32.16 33.21 32.27 32.14 31.66 32.33 31.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "30.73 30.63 32.03 31.38 31.84 31.49 30.54 30.74 30.73 30.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "29.95 30.18 30.43 30.46 30.24 30.57 29.76 30.29 29.95 30.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "29.21 29.76 29.69 30.03 29.5 30.14 29.02 29.87 29.21 29.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "33.06 31.47 33.83 31.91 33.64 32.02 32.87 31.58 33.06 31.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "32.49 31.15 32.76 31.3 32.57 31.41 32.31 31.26 32.49 31.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "31.72 30.7 32.2 30.97 32.01 31.08 31.53 30.81 31.72 30.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "31.41 30.03 34.26 31.66 34.07 31.77 31.22 30.14 31.41 30.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "30.41 29.45 31.11 29.85 30.92 29.96 30.22 29.56 30.41 29.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "33.92 30.97 34.69 31.41 34.5 31.52 33.73 31.08 33.92 30.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "32.11 29.93 33.62 30.8 33.43 30.91 31.92 30.04 32.11 29.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "31.33 29.48 31.81 29.76 31.62 29.87 31.14 29.59 31.33 29.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "33.54 30.26 35.12 31.16 34.93 31.27 33.35 30.36 33.54 30.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "32.1 29.43 33.24 30.08 33.05 30.19 31.91 29.54 32.1 29.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "31.03 28.81 31.8 29.26 31.61 29.37 30.84 28.92 31.03 28.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "35.02 30.61 35.55 30.91 35.36 31.02 34.83 30.72 35.02 30.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "34.01 30.03 34.72 30.43 34.53 30.54 33.83 30.14 34.01 30.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "32.58 29.21 33.71 29.86 33.53 29.97 32.39 29.32 32.58 29.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "34.35 29.72 35.98 30.66 35.79 30.77 34.16 29.83 34.35 29.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "32.52 28.67 34.05 29.55 33.86 29.66 32.33 28.78 32.52 28.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "31.74 28.23 32.22 28.5 32.03 28.61 31.55 28.34 31.74 28.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "30.99 27.8 31.47 28.07 31.28 28.18 30.8 27.91 30.99 27.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "35.43 29.85 36.41 30.41 36.22 30.52 35.24 29.96 35.43 29.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "27.04 29.01 25.68 28.23 25.49 28.34 26.85 29.12 27.04 29.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "27.18 28.59 26.11 27.98 25.92 28.09 26.99 28.7 27.18 28.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "27.31 28.17 26.54 27.73 26.35 27.84 27.12 28.28 27.31 28.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "28.09 28.12 26.97 27.48 26.78 27.59 27.91 28.23 28.09 28.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "28.17 27.67 27.4 27.23 27.21 27.34 27.99 27.78 28.17 27.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "28.81 27.54 27.83 26.98 27.64 27.09 28.62 27.65 28.81 27.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "28.8 27.04 28.26 26.73 28.07 26.84 28.61 27.14 28.8 27.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "29.73 27.07 28.69 26.48 28.5 26.59 29.54 27.18 29.73 27.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "30.1 26.79 29.12 26.23 28.93 26.34 29.91 26.9 30.1 26.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "34.72 29.44 35.13 29.68 34.95 29.79 34.53 29.55 34.72 29.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "33.48 28.73 34.42 29.27 34.23 29.38 33.29 28.84 33.48 28.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "34.65 26.81 36.23 27.72 36.05 27.83 34.46 26.92 34.65 26.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "33.57 26.19 34.19 26.55 34 26.66 33.38 26.3 33.57 26.19"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaq3);
export default __webpack_public_path__ + "static/media/iconFaq3.8ce440f05c2d73d288ca0d3e084f889a.svg";
export { ForwardRef as ReactComponent };